import { Component, ChangeDetectionStrategy } from '@angular/core';


@Component({
	selector: 'delivery-accelerators-tab-1-part',
	standalone: true,
	templateUrl: './delivery-accelerators-tab-1.part.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: [`./delivery-accelerators-tab-1.part.scss`],
})
export class DeliveryAcceleratorsTab1Part {
}
